import { Marketing } from 'features/Marketing';

export const MarketingPage = () => <Marketing />;

export default MarketingPage;
